/** Shared responsive layout classes for Sub parties FormModal (Sales + SalesDev) */

export const SUB_PARTY_MODAL_SHELL_CLASS =
  '!w-full !max-w-[calc(100vw-1rem)] sm:!max-w-[min(92vw,34rem)] lg:!max-w-[44rem] !max-h-[min(88dvh,calc(100dvh-env(safe-area-inset-top)-env(safe-area-inset-bottom)-1.5rem))]';

export const SUB_PARTY_SCROLL_LIST_CLASS =
  'space-y-3 sm:space-y-4 max-h-[min(38dvh,280px)] sm:max-h-[min(48vh,360px)] overflow-y-auto overflow-x-hidden overscroll-contain [-webkit-overflow-scrolling:touch] pr-0.5';

export const SUB_PARTY_CARD_CLASS =
  'border border-gray-200 rounded-lg p-3 sm:p-3.5 bg-gray-50/80 min-w-0 overflow-visible';

export const SUB_PARTY_ROW_LAYOUT_CLASS =
  'flex flex-col gap-3 min-w-0 lg:grid lg:grid-cols-[minmax(0,1fr)_9.5rem_minmax(0,auto)] lg:gap-3 lg:items-end';

export const SUB_PARTY_NAME_FIELD_CLASS = 'w-full min-w-0';

export const SUB_PARTY_AMOUNT_FIELD_CLASS = 'w-full min-w-0 lg:w-auto';

export const SUB_PARTY_ACTIONS_CLASS =
  'flex w-full min-w-0 flex-col gap-2 lg:col-span-1 lg:items-stretch';

export const SUB_PARTY_SYNC_ROW_CLASS =
  'grid grid-cols-[minmax(0,1fr)_auto] gap-2 w-full items-center';

export const SUB_PARTY_LINE_LIST_CLASS =
  'flex flex-col gap-2 max-h-[min(32dvh,220px)] sm:max-h-48 overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]';

export const SUB_PARTY_TOTALS_ROW_CLASS =
  'grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-0.5 items-baseline';
